import { CHANGE_AGENT_VIEW } from "./types";

export const changeAgentView = (viewType) => (dispatch) => {
  dispatch({
    type: CHANGE_AGENT_VIEW,
    payload: viewType,
  });
};
